import {useCallback, useState} from 'react';
import * as React from 'react';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {TopicItemInfo, TopicModule} from '../../services/pages/channel/channel.client';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicTofuText = ({infos, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleBannerJump = useCallback(
        (linkUrl?: string, card?) => {
            const urlParams = {
                linkUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_doufukuai_redianwenzi',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: card.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: card.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, page, navigateToUrl]
    );


    const colors = ['#FFF4F6', '#EBF8FF', '#FFF9F1', '#F9FCF1', '#F4FDFD', '#F7F9FF'];

    const maxColumn = 3;

    const [columns] = useState<number[]>([1, 2, 3]);


    const renderColumn = (column: number, itemList: TopicItemInfo[]) => {

        return (
            itemList.length >= column
                ? (
                    <div
                        className={styles.parent}
                    >
                        {
                            itemList.map(
                                (card, index) => (
                                    (index + 1) % maxColumn === ((maxColumn === column) ? 0 : column)
                                        ? (
                                            <div
                                                key={card.fieldValue?.img}
                                                onClick={() => handleBannerJump(card.fieldValue?.link, card)}
                                                className={styles.card}
                                                style={{backgroundColor: `${colors[index % 6]}`}}
                                                data-show={JSON.stringify({
                                                    'page': page,
                                                    'value': 'jump_doufukuai_redianwenzi',
                                                    'pageSourceId': infos.channelId,
                                                    'pageType': channelBusinessLine,
                                                    'valueId': card.itemId,
                                                    'valueTitle': card.title,
                                                    'valueType': VALUE_TYPE.ITEM,
                                                })}
                                            >
                                                <div
                                                    style={{
                                                        display: 'grid',
                                                        position: 'absolute',
                                                        top: 0,
                                                    }}
                                                >
                                                    <span
                                                        className={styles.cardTitle}
                                                    >
                                                        {card.fieldValue?.title}
                                                    </span>

                                                    <span
                                                        className={styles.cardSubTitle}
                                                    >
                                                        {card.fieldValue?.subTitle}
                                                    </span>

                                                </div>

                                            </div>
                                        )
                                        : null
                                )
                            )
                        }
                    </div>
                )
                : null
        );
    };


    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_doufukuai_redianwenzi',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div>
                                {
                                    infos.moreUrl
                                        ? (
                                            <img
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                                onClick={() => {
                                                    handleBannerJump(infos.moreUrl);
                                                }}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }

            <div className={styles.container}>

                {
                    columns.map(
                        column => (
                            renderColumn(column, infos.itemList || [])
                        )
                    )
                }

            </div>

        </div>
    );
};

export default SelfTopicTofuText;
